import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createInvoiceFromAttachment } from '../api/invoicesApi';

// Fill-manually recovery commit. Mirrors useCreateExpenseFromReceipt — the
// server broadcasts UpdateInvoiceTable + UpdateJobTable, so no cache writes
// here.
export default function useCreateInvoiceFromAttachment() {
    return useMutation({
        mutationFn: createInvoiceFromAttachment,
        onSuccess: () => toast.success('Invoice created'),
        onError: (err) => toast.error(err?.message ?? 'Failed to create invoice'),
    });
}
